angular.module('app').config(paymentProvidersRouting);

function paymentProvidersRouting($routeProvider) {
  $routeProvider
    .when('/payment_providers', {
      pageTitle: 'PAYMENT_PROVIDERS',
      template: '<payment-providers-page></payment-providers-page>',
      menu: 'purchases',
      accessPermission: 'index_paymentprovider_accountadmin',
      authReq: true,
    })
    .when('/payment_providers/new', {
      params: {
        billId: null,
        providerId: null,
        currencyId: null,
      },
      pageTitle: 'ADD_PAYMENT_PROVIDER',
      template: '<payment-provider-page></payment-provider-page>',
      breadcrumb: {
        label: 'PAYMENT_PROVIDERS',
        parent: 'payment_providers',
        ajs: true,
      },
      menu: 'purchases',
      accessPermission: 'create_paymentprovider_accountadmin',
      authReq: true,
    })
    .when('/payment_providers/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'EDIT_PAYMENT',
      template: '<payment-provider-page></payment-provider-page>',
      breadcrumb: {
        label: 'PAYMENT_PROVIDERS',
        parent: 'payment_providers',
        ajs: true,
      },
      menu: 'purchases',
      accessPermission: 'show_paymentprovider_accountadmin',
      authReq: true,
    });
}

paymentProvidersRouting.$inject = ['$routeProvider'];
